import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {Filters} from "../../models/Filter"
import {TextModel} from "../../models/Text"
import connect from "./connect"
import {FacetState} from "../../models/FacetsState"
import {Breadcrumbs} from "../../models/SearchState"
import {HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT} from "../../config/constants"
import {calculateSecondaryFilterRows} from "./calculateSecondaryFilterRows"

export interface FiltersProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children?: JSX.Element
    totalResults: number
    consolidatedFilters: string[]
    filters: Filters
    isFilterSelected?: boolean
    clearAllFilters: () => void
    text: TextModel
    initialScrollCompleted: boolean
    primaryFeatFacets: FacetState[]
    secondaryFeatFacets: FacetState[]
    handleSetFacet: (facetValue: string) => void
    url: string
    rememberFilters: boolean
    disableIcon: boolean
    breadcrumbs: Breadcrumbs
    className?: string
    datatestId?: string
}

const FiltersComponent = memo(
    ({
        children,
        templating,
        totalResults,
        consolidatedFilters,
        filters,
        isFilterSelected,
        clearAllFilters,
        text,
        initialScrollCompleted,
        primaryFeatFacets,
        secondaryFeatFacets,
        handleSetFacet,
        url,
        rememberFilters,
        disableIcon,
        breadcrumbs,
        className,
        datatestId,
    }: FiltersProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const totalRows: number = calculateSecondaryFilterRows(
            consolidatedFilters,
            primaryFeatFacets,
            secondaryFeatFacets,
            HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT,
        )
        const props = {
            totalResults,
            consolidatedFilters,
            filters,
            isFilterSelected,
            clearAllFilters,
            text,
            initialScrollCompleted,
            primaryFeatFacets,
            secondaryFeatFacets,
            handleSetFacet,
            url,
            rememberFilters,
            disableIcon,
            breadcrumbs,
            totalRows,
            className,
            datatestId,
        }
        return <ComponentName {...props}>{children}</ComponentName>
    },
)

FiltersComponent.displayName = "FiltersComponent"
export default connect(FiltersComponent)
